import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Card, Placeholder, Divider, Tab, Loader, Label
} from 'semantic-ui-react';
import download from 'downloadjs';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


// import styled, { keyframes } from 'styled-components';
// import { fadeIn } from 'react-animations';
import { Link } from 'react-router-dom';
import ActivePollList from '../AdminPoll/PollTabs/ActivePollList';
import moment from 'moment';
import ReactApexChart from 'react-apexcharts';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import { center } from '../../Statistics/util';
import {extractFileNameFromHeaders} from "../../DegreeDocumentPrint/util/util";


export default class CourseResults extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            QuestionList: [],
            options2: {
                colors: ['#9c165b', '#842684', '#7e57c2', '#3949ab', '#1976d3'],
                fill: {
                    colors: ['#9c165b', '#842684', '#7e57c2', '#3949ab', '#1976d3']
                },

                labels: ['Ocjena 1', 'Ocjena 2', 'Ocjena 3', 'Ocjena 4', 'Ocjena44 5'],

                title: {
                    text: 'Statistika'
                },

                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
            series2: [8, 5, 7, 5, 9],
            matrix: [[1, 2, 3], [2, 3, 5], []],
            optionMatrix: []

        };

        this.prepareDataForQuestionChart = this.prepareDataForQuestionChart.bind(this);
        this.getSeriesForCourseChart = this.getSeriesForCourseChart.bind(this);
        this.getOptionForCourseChart = this.getOptionForCourseChart.bind(this);
        this.printReport = this.printReport.bind(this);

    }
    componentDidMount() {
        axios.get(`/questionnaire/statistics/${JSON.parse(localStorage.getItem('poll')).pollId}/${localStorage.getItem('courseId')}/1/`)
            .then(res => {
                let courseData = res.data;
                let QuestionList = res.data;// o predmetu


                this.setState({
                    QuestionList, loading: false
                }, () => this.prepareDataForQuestionChart());
            }).catch(err => {
                console.log('Failed to fetch poll data for course.');
            });
    }

    printReport() {


        let obj = {
            language: 'bs',
            questionnaireId: JSON.parse(localStorage.getItem('poll')).pollId,
            courseImplementationId: parseInt(localStorage.getItem('courseId'), 10),
            course: 1
        };
        axios({
            method: 'post',
            url: '/documents/employee-questionnaire-statistics-report/',
            responseType: 'blob',
            data: { ...obj }
        })
            .then(res => {
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                return res;
            })
            .catch(err => {
                toast('Došlo je do greške! Štampanje nije izvršeno.');
            });
    }

    getSeriesForCourseChart(i) {

        return this.state.matrix[i] ? this.state.matrix[i] : [];
    }
    prepareDataForQuestionChart() {
        let data = this.state.QuestionList;

        let allPollData = data[0].questionDTOS;

        let matrix = allPollData.map((e, i) => {
            let tempList = e.answerDTOS.map((el) => (el.numberOfAnswers));
            return tempList;
        });

        let optionMatrix = allPollData.map((e, i) => {
            let tempAnswerOptionList = e.answerDTOS.map((el) => (el.questionName));
            return tempAnswerOptionList;
        });

        this.setState({ matrix, optionMatrix });

    }
    getOptionForCourseChart(i) {


        let options2 = {
            colors: ['#9c165b', '#842684', '#7e57c2', '#3949ab', '#1976d3'],
            fill: {
                colors: ['#9c165b', '#842684', '#7e57c2', '#3949ab', '#1976d3']
            },

            labels: this.state.optionMatrix[i] ? this.state.optionMatrix[i] : [],

            title: {
                text: 'Statistika'
            },

            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        };
        return options2;
    }

    render() {
        // const FadeIn = styled.div`animation: 1s ${keyframes`${fadeIn}`}`;
        // if (this.state.loading) return <div style={{ paddingTop: '100px' }}><Loader active inline="centered" /></div>;
        return (


            <div>
                {this.state.QuestionList.length ?
                    this.state.QuestionList[0].questionDTOS.map((el, index) =>
                        (<Table celled selectable compact striped>
                            <Table.Header fullWidth>
                                {index === 0 ? <Table.Row >
                                    <Table.HeaderCell colSpan={7} >
                                        <Label ribbon color="blue">Broj studenata koji su ocijenili predmet: { localStorage.getItem('numberOfStudentsWhoRatedCourse')}</Label>

                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" >
                                        <Header style={IconHeader} textAlign="center" >


                                            <Button

                                                icon="download"
                                                content="Izvještaj"
                                                // labelPosition="right"
                                                color="blue"
                                                size="small"
                                                style={FiltersOnStyle}
                                                onClick={this.printReport}
                                            >

                                            </Button>


                                        </Header>
                                    </Table.HeaderCell>
                                </Table.Row> : ''}
                                <Table.Row>
                                    <Table.HeaderCell colSpan={4} >
                                        Sadržaj pitanja
                                    </Table.HeaderCell>
                                    <Table.HeaderCell width={1} textAlign="center">
                                        Grafički prikaz
                                    </Table.HeaderCell>
                                    {/* <Table.HeaderCell textAlign="center"> */}
                                    {/*    Broj studenata koji su pristupili anketi */}
                                    {/* </Table.HeaderCell> */}
                                    {el.answerDTOS.map((e, i) => (
                                        <Table.HeaderCell textAlign="center" >
                                            { e.questionName}
                                        </Table.HeaderCell>
                                    ))}


                                    {/* <Table.HeaderCell colSpan="1" ></Table.HeaderCell> */}


                                </Table.Row>
                            </Table.Header>
                            <Table.Body>

                                <Table.Row >
                                    <Table.Cell colSpan={4} verticalAlign="middle" >
                                        {el.questionText}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" textAlign="center" >
                                        {/* <Icon bordered color="blue" name="chart bar" /> */}
                                        <Dropdown
                                            simple
                                            className="icon"
                                            icon="chart pie"
                                            bordered
                                            color="blue"
                                        >

                                            <Dropdown.Menu>

                                                <Dropdown.Item><Card fluid>
                                                    <Card.Content>

                                                        <div id="chart">
                                                            <ReactApexChart options={this.getOptionForCourseChart(index)} series={this.getSeriesForCourseChart(index)} type="pie" width="400" height="400" />
                                                        </div>
                                                    </Card.Content>
                                                </Card></Dropdown.Item>

                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Table.Cell>
                                    {/* <Table.Cell verticalAlign="middle" textAlign="center"> */}
                                    {/*    {el.numberOfStudentsWhoAccessed} */}
                                    {/* </Table.Cell> */}
                                    {el.answerDTOS.map((e, i) => (
                                        <Table.Cell verticalAlign="middle" textAlign="center">
                                            { e.numberOfAnswers}
                                        </Table.Cell>
                                    ))}


                                </Table.Row>

                            </Table.Body>
                            {/* <Table.Footer> */}
                            {/*    <Table.Row> */}
                            {/*        <Table.HeaderCell colSpan={7} verticalAlign="middle" textAlign="right"><h4>UKUPAN PROSJEK:</h4></Table.HeaderCell> */}
                            {/*        <Table.HeaderCell verticalAlign="middle" textAlign="center" ><h4>8.99</h4></Table.HeaderCell> */}
                            {/*    </Table.Row> */}
                            {/* </Table.Footer> */}
                        </Table>)) : <Loader active={this.state.loading} inline="centered" />


                }

                <br />
                <Divider horizontal>
                    <Header as="h4">

                        Pohvale/Primjedbe/Sugestije
                        <h6>Trenutno nema zabilježenih odgovora.</h6>
                    </Header>

                </Divider>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/ProfessorPoll/CourseResults.js